import { Outlet, Route, Routes } from "react-router-dom";
import DashboardLayout from "../layouts/DashboardLayout";
import PrivateRoute from "./PrivateRoute";
import PageNotFound from "../pages/ErrorPage/PageNotFound";
import Overview from "../pages/Overview";
//@ts-ignore
import {
  AccessControl,
  PermissionRequired,
  //@ts-ignore
} from "@careinfo/permission-required";
import AttendanceReportList from "../pages/AttendancReportList";
import StaffList from "../pages/Staff/StaffList";
import CreateStaffInfo from "../pages/Staff/CreateStaffInfo";
import EditStaffInfo from "../pages/Staff/EditStaffInfo";
import EditStaff from "../pages/Staff/EditStaff";
import LeaveApplicationList from "../pages/Leave";
import ShiftList from "../components/Shift/ShiftList";
import CreateShift from "../pages/Shift/CreateShift";
import EditShift from "../pages/Shift/EditShift";

const Router = () => {
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route path={"/human-resource-management"} element={<Outlet></Outlet>}>
          <Route index element={<Overview />} />
        </Route>

        <Route path="/*" element={<PageNotFound />} />
        <Route
          path={"human-resource-management/employee/staff"}
          element={
            <AccessControl
              children={<StaffList />}
              allowedPermissions={["can_view_staff"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"human-resource-management/employee/staff/create"}
          element={
            <AccessControl
              children={<CreateStaffInfo />}
              allowedPermissions={["can_create_staff"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"human-resource-management/employee/staff/edit/:id"}
          element={
            <AccessControl
              children={<EditStaffInfo />}
              allowedPermissions={["can_update_staff"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"human-resource-management/employee/staffs/edit/:id"}
          element={
            <AccessControl
              children={<EditStaff />}
              allowedPermissions={["can_update_staff"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"human-resource-management/attendance/report"}
          element={
            <AccessControl
              children={<AttendanceReportList />}
              allowedPermissions={["can_view_staff"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"human-resource-management/attendance/leave"}
          element={
            <AccessControl
              children={<LeaveApplicationList />}
              allowedPermissions={["can_view_staff"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"human-resource-management/shift"}
          element={
            <AccessControl
              children={<ShiftList />}
              allowedPermissions={["can_view_staff"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"human-resource-management/shift/create"}
          element={
            <AccessControl
              children={<CreateShift />}
              allowedPermissions={["can_create_staff"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"human-resource-management/shift/edit/:id"}
          element={
            <AccessControl
              children={<EditShift />}
              allowedPermissions={["can_update_staff"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
      </Route>
    </Routes>
  );
};

export default Router;
